import { styled as o } from "styled-components";
import { Theme as r } from "../../../../styles/themes/index.js";
const e = o.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(${r.colors.Juliet});
  border-radius: 8px;

  display: flex;
`;
export {
  e as LoadingContainer
};
